module.exports = __webpack_public_path__ + "static/media/pic_empty_screen_scanbit.cf7f4b0a.png";